import * as React from 'react';

import * as ReportBlockFieldEnum from '@acceligentllc/shared/enums/reportBlockField';
import { ReportBlockType } from '@acceligentllc/shared/enums/reportBlockType';

import { bemBlock, bemElement } from 'af-utils/bem.util';

interface OwnProps {
	isInPrimarySegment: boolean;
	isSegmentExpanded: boolean;
	name: string;
	type: ReportBlockType;
}

type Props = OwnProps;

type FieldType = { value: string; };

const _renderImmutableLink = (field: FieldType) => {
	const className = bemElement('report-block', 'array-elements__element', [ReportBlockFieldEnum.Dimension.LARGEST.toLowerCase()]);

	const fieldClassName = bemElement('report-block', 'immutable_link_field');

	return (
		<div className={className}>
			<div className={fieldClassName}>
				{field.value}
			</div>
		</div>
	);
};

const CONSTANT_FIELDS = {
	[ReportBlockType.JOB_EHS]: [
		{ value: 'sample.pdf' },
		{ value: 'sample_picture.jpeg' },
		{ value: 'subfolder/sample_picture2.jpeg' },
	],
};

const FIELD_RENDERERS = {
	[ReportBlockType.JOB_EHS]: _renderImmutableLink,
};

const PredefinedBlockPreview: React.FC<Props> = (props: Props) => {
	const { isInPrimarySegment, isSegmentExpanded, name, type } = props;

	const renderFields = React.useCallback(() => {
		const fields = CONSTANT_FIELDS[type];
		const renderFn = FIELD_RENDERERS[type];

		return fields.map(renderFn);
	}, [type]);

	const className = bemBlock('report-block', { collapsed: !isSegmentExpanded, inline: true, secondary: !isInPrimarySegment, primary: !!isInPrimarySegment, small: true });
	const titleClassName = bemBlock('report-block__title', {
		main: false,
		collapsed: !isSegmentExpanded,
	});

	return (
		<div className={className}>
			<div className={titleClassName}>
				<span className="report-block__title-name">
					<span>{name}</span>
				</span>
			</div>
			<div className="report-block__field-group">
				<div className="report-block__fields">
					<div className={bemElement('report-block', 'array-elements', { 'settings-preview': true })}>
						{renderFields()}
					</div >
				</div>
			</div>
		</div>
	);
};

export default React.memo(PredefinedBlockPreview);
